import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { toBase64, getFileExtension } from '../../../../utils/util';

import { requestCreateComment } from '../../../../api/market-buzz/market-buzz.actions';

import CommentInput from '../../../../components/common/comment/comment-input/CommentInput';

const CommentInputContainer = ({ postExternalReference, parentExternalReference, setShowInput }) => {
  const dispatch = useDispatch();

  const mapImages = async (files) => {
    const mappedFiles = [];

    for (const file of files) {
      mappedFiles.push({
        base64String: await toBase64(file),
        documentExtension: getFileExtension(file.name),
      });
    }

    return mappedFiles;
  };

  const createComment = async (text, images, onSuccess) => {
    const photos = await mapImages(images);
    const comment = {
      parentPostExternalReference: parentExternalReference,
      photos,
      text,
    };

    dispatch(
      requestCreateComment({
        comment,
        postExternalReference,
        onSuccess: () => {
          if (setShowInput) {
            setShowInput(false);
          }
          onSuccess();
        },
      })
    );
  };

  return <CommentInput createComment={createComment} />;
};

CommentInputContainer.propTypes = {
  postExternalReference: PropTypes.string,
  parentExternalReference: PropTypes.string.isRequired,
  setShowInput: PropTypes.func,
};

CommentInputContainer.defaultProps = {
  postExternalReference: undefined,
  setShowInput: undefined,
};

export default CommentInputContainer;
